import { render, staticRenderFns } from "./HelloDashboard.vue?vue&type=template&id=659d656c"
import script from "./HelloDashboard.vue?vue&type=script&lang=js"
export * from "./HelloDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports